import React, { PureComponent } from "react";
import { Navbar, Nav, NavItem } from 'react-bootstrap';
import mainLogo from'../orthotoolkit.png';

class Navigation extends PureComponent {
	render() {
    return (
<div>
<Navbar collapseOnSelect>
  <Navbar.Header pullLeft>
         <a href="https://orthotoolkit.com/"><img src={mainLogo} style={{padding:15,width:200}} alt="orthotoolkit logo"/></a>
    <Navbar.Toggle />
  </Navbar.Header>
  <Navbar.Collapse>
    <Nav pullRight>
      <NavItem href="https://orthotoolkit.com/">Home</NavItem>
    </Nav>
  </Navbar.Collapse>
</Navbar>
</div>
    );
}
}

export default Navigation;



// WEBPACK FOOTER //
// ./src/Components/Navigation.js